import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const [currentProductIndex, setCurrentProductIndex] = useState(0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // 获取前4个产品用于展示
  const featuredProducts = productData.slice(0, 4);

  // 获取热销产品（第5-9个产品）
  const topSellerProducts = productData.slice(4, 9);

  // 产品轮播功能
  const nextProduct = () => {
    setCurrentProductIndex((prev) =>
      prev === featuredProducts.length - 1 ? 0 : prev + 1
    );
  };

  const prevProduct = () => {
    setCurrentProductIndex((prev) =>
      prev === 0 ? featuredProducts.length - 1 : prev - 1
    );
  };

  const goToProduct = (index) => {
    setCurrentProductIndex(index);
  };

  // 汽车书籍分类数据
  const bookCategories = [
    {
      id: 1,
      title: "AUSTRALIAN CARS",
      image: "/main/main1.jpg",
      description:
        "Comprehensive guides to Australian automotive history and models",
      link: "/shop",
    },
    {
      id: 2,
      title: "MUSCLE CARS IN DETAIL",
      subtitle: "1964 Pontiac GTO",
      image: "/main/main1-2.jpg",
      description: "Detailed coverage of American muscle cars",
      link: "/shop",
    },
    {
      id: 3,
      title: "BMW 3 Series",
      subtitle: "Service Manual",
      image: "/main/main1-3.jpg",
      description: "Workshop manuals for BMW 3 Series",
      link: "/shop",
    },
  ];

  // 底部分类数据
  const bottomCategories = [
    {
      id: 1,
      title: "A-Z PUBLISHERS",
      image: "/main/main2-1.jpg",
      link: "/shop",
    },
    {
      id: 2,
      title: "AMERICAN CARS",
      image: "/main/main2-2.jpg",
      link: "/shop",
    },
    {
      id: 3,
      title: "ANIMAL BOOKS",
      image: "/main/main2-3.jpg",
      link: "/shop",
    },
    {
      id: 4,
      title: "AUSTRALIAN CARS",
      image: "/main/main2-4.jpg",
      link: "/shop",
    },
    {
      id: 5,
      title: "CARS A-Z BY MARQUE",
      image: "/main/main2-5.jpg",
      link: "/shop ",
    },
  ];

  return (
    <div className="main">
      <Header />

      <main className="main-content">
        {/* 主标题区域 */}
        <section className="hero-section">
          <div className="hero-container">
            <h1 className="hero-title">
              Emeline – AUTOMOTIVE BOOKS AND MANUALS
            </h1>
          </div>
        </section>

        {/* 主要书籍分类网格 */}
        <section className="books-grid">
          <div className="books-container">
            <div className="books-grid-layout">
              {/* 大图 - Australian Cars */}
              <div className="book-item book-item--large">
                <Link to={bookCategories[0].link} onClick={toTop}>
                  <div className="book-image-wrapper">
                    <img
                      src={bookCategories[0].image}
                      alt={bookCategories[0].title}
                      className="book-image"
                    />
                    <div className="book-overlay">
                      <div className="book-content">
                        <h2 className="book-title">
                          {bookCategories[0].title}
                        </h2>
                        <button className="browse-btn">BROWSE</button>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>

              {/* 右侧小图网格 */}
              <div className="book-grid-right">
                {bookCategories.slice(1, 3).map((book) => (
                  <div key={book.id} className="book-item book-item--small">
                    <Link to={book.link} onClick={toTop}>
                      <div className="book-image-wrapper">
                        <img
                          src={book.image}
                          alt={book.title}
                          className="book-image"
                        />
                        <div className="book-overlay">
                          <div className="book-content">
                            <h3 className="book-title">{book.title}</h3>
                            {book.subtitle && (
                              <p className="book-subtitle">{book.subtitle}</p>
                            )}
                            <button className="browse-btn">BROWSE</button>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}

                {/* 底部两个小图 */}
                <div className="book-row-bottom">
                  {bookCategories.slice(3, 5).map((book) => (
                    <div key={book.id} className="book-item book-item--small">
                      <Link to={book.link} onClick={toTop}>
                        <div className="book-image-wrapper">
                          <img
                            src={book.image}
                            alt={book.title}
                            className="book-image"
                          />
                          <div className="book-overlay">
                            <div className="book-content">
                              <h3 className="book-title">{book.title}</h3>
                              {book.subtitle && (
                                <p className="book-subtitle">{book.subtitle}</p>
                              )}
                              <button className="browse-btn">BROWSE</button>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 底部分类网格 */}
        <section className="bottom-categories">
          <div className="categories-container">
            <div className="categories-grid">
              {bottomCategories.map((category) => (
                <div key={category.id} className="category-item">
                  <Link to={category.link} onClick={toTop}>
                    <div className="category-image-wrapper">
                      <img
                        src={category.image}
                        alt={category.title}
                        className="category-image"
                      />
                      <div className="category-overlay">
                        <h3 className="category-title">{category.title}</h3>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 底部信息文本 */}
        <section className="bottom-info">
          <div className="info-container">
            <p className="info-text">
              We dismantle and rebuild vehicles to produce manuals
            </p>
            <p className="info-link">
              <a href="/">https://www.emeline.online</a>
            </p>
          </div>
        </section>

        {/* 新书产品展示区域 */}
        <section className="new-products">
          <div className="new-products-container">
            <h2 className="new-products-title">NEW BOOKS!</h2>

            <div className="product-showcase">
              <div className="product-carousel">
                {/* 左侧产品图片 */}
                <div className="product-image-section">
                  <button
                    className="carousel-arrow carousel-arrow--prev"
                    onClick={prevProduct}
                    aria-label="Previous product"
                  >
                    ←
                  </button>

                  <div className="product-image-wrapper">
                    <img
                      src={featuredProducts[currentProductIndex].images[0]}
                      alt={featuredProducts[currentProductIndex].name}
                      className="product-image"
                    />
                  </div>

                  <button
                    className="carousel-arrow carousel-arrow--next"
                    onClick={nextProduct}
                    aria-label="Next product"
                  >
                    →
                  </button>
                </div>

                {/* 右侧产品信息 */}
                <div className="product-info-section">
                  <h3 className="product-name">
                    {featuredProducts[currentProductIndex].name}
                  </h3>

                  <div className="product-price">
                    ${featuredProducts[currentProductIndex].price}
                  </div>

                  <div className="product-meta">
                    <p className="product-sku">
                      SKU: {featuredProducts[currentProductIndex].category}
                      {featuredProducts[currentProductIndex].id
                        .toString()
                        .padStart(4, "0")}
                    </p>

                    <div className="product-categories">
                      <span>Categories: </span>
                      <Link to="/shop" onClick={toTop}>
                        New Products
                      </Link>
                      <span>, </span>
                      <Link to="/shop" onClick={toTop}>
                        {featuredProducts[currentProductIndex].category}
                      </Link>
                    </div>
                  </div>

                  <Link
                    to={`/shopDetails/${featuredProducts[currentProductIndex].id}`}
                    className="read-more-btn"
                    onClick={toTop}
                  >
                    READ MORE
                  </Link>
                </div>
              </div>

              {/* 产品指示器 */}
              <div className="product-indicators">
                {featuredProducts.map((_, index) => (
                  <button
                    key={index}
                    className={`indicator ${
                      index === currentProductIndex ? "indicator--active" : ""
                    }`}
                    onClick={() => goToProduct(index)}
                    aria-label={`Go to product ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* TOP SELLERS 区域 */}
        <section className="top-sellers">
          <div className="top-sellers-container">
            <h2 className="top-sellers-title">TOP SELLERS!</h2>

            <div className="top-sellers-grid">
              {topSellerProducts.map((product) => (
                <div key={product.id} className="seller-card">
                  <Link to={`/product/${product.id}`} onClick={toTop}>
                    <div className="seller-image-wrapper">
                      <img
                        src={product.images[0]}
                        alt={product.name}
                        className="seller-image"
                      />
                    </div>

                    <div className="seller-info">
                      <div className="seller-category">
                        {product.category.toUpperCase()}
                      </div>

                      <h3 className="seller-title">{product.name}</h3>

                      <div className="seller-price">${product.price}</div>

                      <button className="add-to-cart-btn">ADD TO CART</button>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
